<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.license.h1')}}</h1>
    </div>
    <div class="content">
      <div class="wrapper-x-40">
        <div style="width: 50%">
          <div
            class="license-wrapper"
            v-if="license"
          >
            <div class="license text-sm flex justify-between mb-12">
              <div class="license__name">{{license.name}} </div>
              <div
                class="license__remaining"
                v-if="license.type == 'standard'||license.type == 'demo'"
              >
                <a
                  href="https://kpam3d.ru/litsenzii-kpam-3d.html"
                  target="_blank"
                >
                  осталось: {{ license.day_remaining }} {{ $toDays(license.day_remaining) }}</a>
              </div>
            </div>
            <div
              class="license-key"
              v-if="license.key"
            >[{{license.key}}]</div>

            <div class="change-license mt-2 mb-6">
              <button
                class="btn btn-small btn-default"
                @click="showActivation = !showActivation"
              >
                Изменить лицензию
                <i
                  class="ml-2 fa"
                  :class="{'fa-chevron-down': !showActivation, 'fa-chevron-up':showActivation}"
                ></i>
              </button>
            </div>

          </div>

          <div
            class="activation"
            v-if="!licensed || license.type == 'test' || showActivation"
          >
            <h1>{{$t('admin.views.license.activation_h1')}}</h1>
            <p class="mb-2">{{$t('admin.views.license.enter_key_activation')}}</p>
            <div class="activation__input form-group mb-4">
              <input
                type="text"
                v-model="license_key"
              >
            </div>
            <div class="activation__get mb-6">
              <a
                href="https://kpam3d.ru/litsenzii-kpam-3d.html"
                target="_blank"
              >{{$t('admin.views.license.get_key')}}</a>
            </div>
            <div class="activation__button">
              <button
                class="btn btn-green"
                @click="activation"
              >{{$t('admin.views.license.button_activation')}}</button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "License",
  data() {
    return {
      license_key: "",
      showActivation: false,
    };
  },
  computed: {
    licensed() {
      return this.$store.getters["licensed"];
    },
    license() {
      return this.$store.state.license;
    },
  },

  methods: {
    async activation() {
      try {
        const res = await this.$store.dispatch(
          "licenses/activate",
          this.license_key
        );
      } catch (e) {
        console.log(e.response);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.license__remaining {
  color: #ff0202;
  border-bottom: 1px solid;
}
.activation__get a {
  border-bottom: 1px solid;
}
.activation__get a:hover {
  border-bottom: transparent;
}
</style>

